<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <h6 class="navbar-heading p-0 ml-4 text-muted">Панель</h6>
        <sidebar-item
          :link="{
            name: 'Статистика',
            path: '/dashboard',
            icon: 'ni ni-tv-2',
          }"
        >
        </sidebar-item>

        <h6 class="navbar-heading p-0 ml-4 text-muted mt-2">Транзакции</h6>

        <sidebar-item
            :link="{
              name: 'Переводы P2P',
              path: '/s-transfers',
              icon: 'ni ni-bold-up'
              }"
            >
        </sidebar-item>

        <sidebar-item
              :link="{
                name: 'Получение',
                path: '/r-transfers',
                icon: 'ni ni-bold-down'
              }">
        </sidebar-item>

        <h6 class="navbar-heading p-0 ml-4 text-muted mt-2">Настройки</h6>

        <sidebar-item
                  :link="{
                    name: 'Карты',
                    path: '/cards',
                    icon: 'ni ni-credit-card'
                  }">
        </sidebar-item>
        <sidebar-item
                  :link="{
                    name: 'Настройки',
                    path: '/settings',
                    icon: 'ni ni-settings-gear-65'
                  }">
        </sidebar-item>

        <h6 class="navbar-heading p-0 ml-4 text-muted mt-2">Провайдеры</h6>

        <sidebar-item
          :link="{
                    name: 'Провайдеры',
                    path: '/providers',
                    icon: 'ni ni-vector'
                  }">
        </sidebar-item>

      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
  </div>
</template>
<script>

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';
  import axios from 'axios'
  import { mapGetters } from "vuex";
  // import LoginVue from '../Pages/Login.vue';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    computed: {
      ...mapGetters(["currentUser"])
    },
    methods: {
      async checkLogin() {
        try {
          await axios.get("me", {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          });
        } catch (e) {
          this.$router.push({ name: 'login' });
          console.log(e);
        }
      }
    },
    beforeMount() {
      // this.initScrollbar();
      this.checkLogin();
    }
  };
</script>
<style lang="scss">
</style>
